import { ChevronRight, Megaphone } from 'lucide-react'
import { useEffect } from 'react'

function MemberOnboardingBanner () {
  useEffect(() => {
    window.segment?.page('[EE] Onboarding banner viewed', {})
  }, [])

  return (
    <div
      className='border rounded-md w-full p-4 mb-4'
      style={{ background: 'linear-gradient(286.66deg, #904DD4 0%, #4B1377 100%)' }}
    >
      <div className='flex flex-col xs:flex-row xs:items-center gap-4 justify-between'>
        <Megaphone size={26} stroke='#FFF' className='shrink-0' />
        <div className='text-white flex-grow'>
          Looking to enroll in healthcare benefits?
        </div>
        <div>
          <button
            className='btn-secondary w-auto mb-0'
            onClick={() => {
              window.segment?.track('[EE] Onboarding banner clicked', {})
              window.open('/member_onboarding/progress?source=onboarding_banner', '_blank')
            }}
          >
            Enroll now
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default MemberOnboardingBanner
